<template>
<div class="chapter">
<div class="inner_page">
<p class="textcenter1"><b>SEARCHING FOR SELF-RELIANCE</b> </p>
<p class="textcenterwithspace1">On poverty’s stage</p>
<p class="textcenter">Inconsolable rage</p>
<p class="textcenter">Hurting loved ones most</p>
<p class="textcenterwithspace1">Insecurity lurks</p>
<p class="textcenter">Nothing works</p>
<p class="textcenter">Life’s an empty boast.</p>
<p class="textcenterwithspace1">Children see</p>
<p class="textcenter">The real me</p>
<p class="textcenter">Lost in hopeless sorrow.</p>
<p class="textcenterwithspace1">Creator knows</p>
<p class="textcenter">Poverty’s blows</p>
<p class="textcenter">A time of no tomorrow.</p>
<p class="textcenterwithspace1">All defiance</p>
<p class="textcenter">No self-reliance</p>
<p class="textcenter">A psyche on parole</p>
<p class="textcenterwithspace1">Needs action</p>
<p class="textcenter">Not subtraction</p>
<p class="textcenter">To make the spirit whole.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1b.vue?488219ee